import {Admin, User} from 'packages/common-types/schema-types';
import {useState, useEffect, useCallback} from 'react';
import {ActionMeta} from 'react-select';

const useTableSearch = (data: User[] | Admin[] = null) => {
  const [filteredRows, setFilteredRows] = useState<User[] | Admin[] | null>(
    null
  );

  useEffect(() => {
    if (data) {
      setFilteredRows(data);
    }
  }, [data]);

  const onChange = useCallback(
    (value: User | Admin, triggeredAction: ActionMeta<User | Admin>) => {
      if (triggeredAction.action === 'clear') {
        setFilteredRows(data || []);
        return;
      }
      const userToFind = (filteredRows as Admin[]).filter(
        (user: User | Admin) => user?.uid === value.uid
      );
      setFilteredRows(userToFind);
    },
    [data, filteredRows]
  );

  return {filteredRows, setFilteredRows, onChange};
};

export default useTableSearch;
